export const PackingRecommendationStatus = {
  Requested: 'Requested',
  Calculating: 'Calculating',
  Applied: 'Applied',
  Dismissed: 'Dismissed',
  Failed: 'Failed',
  Stale: 'Stale',
} as const;

export type PackingRecommendationStatus = (typeof PackingRecommendationStatus)[keyof typeof PackingRecommendationStatus];

export const TERMINAL_PACKING_RECOMMENDATION_STATUSES: PackingRecommendationStatus[] = [
  PackingRecommendationStatus.Applied,
  PackingRecommendationStatus.Dismissed,
  PackingRecommendationStatus.Failed,
  PackingRecommendationStatus.Stale,
];

export const PackingRecommendationFailureReason = {
  NoItems: 'NoItems',
  NoValidPackage: 'NoValidPackage',
  OrderAlreadyShipped: 'OrderAlreadyShipped',
  PackingAiServiceError: 'PackingAiServiceError',
  Timeout: 'Timeout',
  Unknown: 'Unknown',
} as const;

export type PackingRecommendationFailureReason =
  (typeof PackingRecommendationFailureReason)[keyof typeof PackingRecommendationFailureReason];

export type PackingRecommendationStatusFields = {
  packingRecommendationStatus?: PackingRecommendationStatus | null;
  packingRecommendationFailureReason?: PackingRecommendationFailureReason | null;
};

export const getTerminalPackingRecommendationStatus = (
  fulfillmentPlan: PackingRecommendationStatusFields | null | undefined,
): PackingRecommendationStatus | null => {
  const status = fulfillmentPlan?.packingRecommendationStatus;
  return status != null && TERMINAL_PACKING_RECOMMENDATION_STATUSES.includes(status) ? status : null;
};
